export const selectCommodityComplianceState = (state) =>
  state.commodityCompliance || {};

export const selectComplianceData = (state) =>
  selectCommodityComplianceState(state).data || [];

export const selectLoading = (state) =>
  selectCommodityComplianceState(state).loading || false;

export const selectError = (state) =>
  selectCommodityComplianceState(state).error || null;

export const selectCategory = (state) =>
  selectCommodityComplianceState(state).category || "Overall";

export const selectView = (state) =>
  selectCommodityComplianceState(state).view || "top";

export const selectTotalRecords = (state) =>
  selectCommodityComplianceState(state).totalRecords || 0;

export const selectSavedFilters = (state) =>
  selectCommodityComplianceState(state).savedFilters || {};